export const SETTINGS_SELECTORS_GET_CONTEXT_ID_FALSY = 'SETTINGS_SELECTORS_GET_CONTEXT_ID_FALSY';
export const SETTINGS_SELECTORS_GET_CONTEXT_ID_UNEXPECTED = 'SETTINGS_SELECTORS_GET_CONTEXT_ID_UNEXPECTED';

export const SETTINGS_SELECTORS_GET_CONTEXT_TYPE_FALSY = 'SETTINGS_SELECTORS_GET_CONTEXT_TYPE_FALSY';
export const SETTINGS_SELECTORS_GET_CONTEXT_TYPE_UNEXPECTED = 'SETTINGS_SELECTORS_GET_CONTEXT_TYPE_UNEXPECTED';
